import "core-js/modules/es6.array.for-each";
import NwApiSDK from '@nerdwallet/nw-api-sdk';
import { getProviderAccountStateIdFromProviderAccount, getProviderAccountsNeedingAutoRefresh } from "../selectors";
import { requestIdentity } from "../actions/auth";
import { readProfile } from "../actions/profiles";
import { refreshProviderAccount } from "../actions/yodlee";
/**
 * This middleware automatically refreshes stale provider accounts based on the
 * `auto_refresh_required` flag on the provider account state. By default, it works
 * by looking through all provider accounts and identifying those that need a refresh
 * on any action, and dispatching a refresh for each stale account. If
 * `shouldAutoRefreshOnlyOnProfileRead` is true, the check is only made on the
 * `requestIdentity` and `readYodleeProfile` actions.
 *
 * @name providerAccountsRefreshMiddleware
 * @type ReduxMiddleware
 * @param {boolean} shouldAutoRefreshOnlyOnProfileRead - flag that when true will only trigger
 *  auto-refresh on `requestIdentity` success or `readYodleeProfile` success
 */

export default (function (_ref) {
  var shouldAutoRefreshOnlyOnProfileRead = _ref.shouldAutoRefreshOnlyOnProfileRead;
  return function (_ref2) {
    var dispatch = _ref2.dispatch,
        getState = _ref2.getState;
    return function (next) {
      return function (action) {
        if (!process.browser) return next(action);
        var returnValue = next(action);
        var state = getState();
        var actionName = action.actionName,
            meta = action.meta,
            type = action.type;
        var isRequestIdentitySuccess = type === requestIdentity.success.getType();
        var isReadYodleeProfileSuccess = type === readProfile.success.getType() && meta.profileType === NwApiSDK.IDENTITY_PROFILES.YODLEE_PROFILE;
        var isActionEligibleForAutoRefresh = shouldAutoRefreshOnlyOnProfileRead ? isRequestIdentitySuccess || isReadYodleeProfileSuccess : actionName !== refreshProviderAccount.actionName;

        if (isActionEligibleForAutoRefresh) {
          getProviderAccountsNeedingAutoRefresh(state.identity).forEach(function (providerAccount) {
            dispatch(refreshProviderAccount({
              providerAccountStateId: getProviderAccountStateIdFromProviderAccount(providerAccount),
              isAutoRefresh: true
            }));
          });
        }

        return returnValue;
      };
    };
  };
});